/**
 * MobileAdminLeaf — the phone frame for wide desktop pages: settings pages,
 * strategy pages below the hub, and a cycle's configure / governance /
 * aggregation / setup pages.
 *
 * Applies scoped CSS (pa-mobile-admin) so fixed sidebars, wide tables, and
 * multi-column grids stack or scroll instead of clipping off-screen.
 *
 * It draws no back link of its own: the header's Back goes to the same parent
 * (mobileBackTarget), so a phone page has one back control (audit 2026-11-02,
 * #38 — the frame's "‹ group" link sat under the header's Back).
 */
import type { ReactNode } from 'react';

interface MobileAdminLeafProps {
  children: ReactNode;
}

export function MobileAdminLeaf({ children }: MobileAdminLeafProps) {
  return (
    <div className="pa-mobile-admin px-3 py-3 min-w-0">
      <div className="min-w-0 overflow-x-hidden">{children}</div>
    </div>
  );
}
